import axios, { type AxiosInstance } from "axios";

export const axiosClient: AxiosInstance = axios.create({
  responseType: "json",
  headers: {
    Accept: "application/json",
  },
  withCredentials: true,
});
